// @flow
import styled from 'styled-components';

export default styled.button`
  background-color: ${props => props.theme.colors.green};
  padding: 10px;
  height: 40px;
  border-radius: 20px;
  width: 150px;
  font-size: 16px;
  color: white;
  border: none;
  box-shadow: 0px 5px 20px 1px rgba(0, 214, 178, 0.4);
  transition: 0.3s ease;
  cursor: pointer;
  font-family: ${props => props.theme.fontBold};

  &:focus {
    outline: none;
  }
  &:active,
  &:disabled {
    background-color: ${props => props.theme.colors.lightGrey};
    box-shadow: 0px 5px 20px 1px rgba(0, 0, 0, 0);
  }
`;



// WEBPACK FOOTER //
// ./src/components/button/index.js